import React from 'react';
import { Link } from 'react-router-dom';

export const TermsConditions = () => {
  return (
    <div className="min-h-screen py-16 bg-[#F9F8F6]" data-testid="terms-page">
      <div className="container-custom max-w-4xl">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4" data-testid="terms-title">Terms & Conditions</h1>
          <p className="text-lg text-softgrey">Please read these terms carefully before using our website.</p>
        </div>

        <div className="space-y-10">
          <section data-testid="availability-section">
            <h2 className="text-2xl font-heading font-bold mb-4">Product Availability</h2>
            <p className="text-softgrey leading-relaxed">Products are subject to availability. As most of our items are one-of-a-kind vintage pieces, once an item is sold it cannot be restocked.</p>
          </section>

          <section data-testid="pricing-section">
            <h2 className="text-2xl font-heading font-bold mb-4">Pricing</h2>
            <p className="text-softgrey leading-relaxed">Prices may change without prior notice. The price displayed at the time of your order is the price you will be charged.</p>
          </section>

          <section data-testid="orders-section">
            <h2 className="text-2xl font-heading font-bold mb-4">Orders</h2>
            <p className="text-softgrey leading-relaxed mb-4">Orders may be cancelled if items become unavailable or if there is an error in pricing or product information.</p>
          </section>

          <section data-testid="customer-info-section">
            <h2 className="text-2xl font-heading font-bold mb-4">Customer Responsibility</h2>
            <p className="text-softgrey leading-relaxed">Customers must provide accurate information when placing orders, including shipping address and contact details. We are not responsible for delays or failed deliveries caused by incorrect information.</p>
          </section>

          <section className="bg-cream p-8 rounded-xl" data-testid="related-policies-section">
            <h2 className="text-2xl font-heading font-bold mb-4">Related Policies</h2>
            <p className="text-softgrey mb-4">Please also review our other policies:</p>
            <ul className="space-y-2">
              <li><Link to="/shipping-policy" className="text-coral hover:underline font-semibold">Shipping Policy</Link></li>
              <li><Link to="/returns-policy" className="text-coral hover:underline font-semibold">Returns & Refunds Policy</Link></li>
              <li><Link to="/privacy-policy" className="text-coral hover:underline font-semibold">Privacy Policy</Link></li>
              <li><Link to="/payment-policy" className="text-coral hover:underline font-semibold">Payment Policy</Link></li>
            </ul>
          </section>
        </div>

        <div className="mt-16 border-t border-border pt-8">
          <p className="text-softgrey text-sm">Have questions? <Link to="/contact" className="text-coral hover:underline font-semibold">Contact Us</Link> or visit our <Link to="/faq" className="text-coral hover:underline font-semibold">FAQ</Link>.</p>
        </div>
      </div>
    </div>
  );
};
